import React, { useState, useEffect } from 'react';

import AddOperator from '../../Components/AddOperator'

import ModalWarn from '../../Components/Modal/Warn/index'

export default function AddAgencyManager(props) {

    const [ agencyManager, setAgencyManager ] = useState({
        cpf: '',
        name: '',
        dt_canc_exp: '',
        ident_dig: ''
    });
    const [ loadAgencyManager, setLoadAgencyManager ] = useState(false);

    const [ organOptions, setOrganOptions ] = useState([]);

    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(()=>{
        async function loadOrganOptions() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_usuario: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaOrgaoGestorOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
    
                        var organList = [];
                        var obj = {};

                        data.forEach((organ) => {
                            obj = {
                                value: organ.CODIGO_ORGAO,
                                label: organ.NOME_REDE_ATENDIMENTO
                            }

                            organList.push(obj);
                        });

                        setOrganOptions(organList);
                    });
                } else {
                    console.log('Error request to /gestao/consultaOrgaoGestorOrgao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        if (!loadAgencyManager && props.location.state !== undefined) {
            setAgencyManager({
                cpf: props.location.state.cpf,
                name: props.location.state.name,
                dt_canc_exp: props.location.state.dt_canc_exp,
                ident_dig: props.location.state.ident_dig
            });

            loadOrganOptions();
            setLoadAgencyManager(true);
        }
    }, [props.location.state, loadAgencyManager]);

    const [ loadingAdd, setLoadingAdd ] = useState(false);    

    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

     // ================================================================================

    const onSubmitAgencyManagerData = async (data) => {

        setLoadingAdd(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                cpf_gestor_orgao: agencyManager.cpf,
                nome_gestor_orgao: agencyManager.name,
                codigo_orgao: data.organ.value,
                data_cancelamento: agencyManager.dt_canc_exp
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/cadastraGestorOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {
                    const agencyManager_added = {
                        from: "addAgencyManager",
                        id_usuario_orgao: data_request.objGestorOrgao.id_usuario_orgao,
                        cpf: data_request.objGestorOrgao.cpf_gestor_orgao,
                        name: data_request.objGestorOrgao.nome_gestor_orgao,
                        organ: data.organ,
                        dt_inc: data_request.objGestorOrgao.data_inclusao,
                        dt_canc_exp: data_request.objGestorOrgao.data_cancelamento
                    }
                    setLoadingAdd(false);
                    
                    props.history.push('mostrarGestorOrgao', agencyManager_added);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/cadastraGestorRegional BackendBalcao');
                    }

                    setLoadingAdd(false);
                });
            } else
            if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingAdd(false)
                  setModalInvalidSessionError(true)
                })
            }
            else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingAdd(false);
                console.log('Error request to /gestao/cadastraGestorRegional');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />

            <AddOperator
                pageTitle='Cadastrar gestor de rede de atendimento'
                expirationDateHint='(Caso uma data de expiração seja definida, o usuário será automaticamente excluído e terá seu acesso revogado na data estipulada)'
                onSubmitData={onSubmitAgencyManagerData}
                loadOperator={loadAgencyManager}
                operator={agencyManager}
                setOperator={setAgencyManager}
                organOptions={organOptions}
                organDefault={props.location.state?.addedAgency}
                loadingAdd={loadingAdd}
                setLoadingAdd={setLoadingAdd}
                modalError ={modalError}
                setModalError={setModalError}
                messageError={messageError}
                buttonCancelRoute='/consultaGestorOrgao'
                buttonAddAgencyRoute='/adicionarOrgao'
                history={props.history}
            />
        </>
        
    );
}